// extracted by mini-css-extract-plugin
export default {"mn-workbench-list":"index_mn-workbench-list__xtIRN"};